<template>
    <div>
        <div>
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:15px !important;margin-bottom:50px !important`">
                <v-col cols="12">
                    <label>راس الفاتورة</label>
                    <b-form-textarea v-model="printing.invoice_header" class="inborder" style="height:200px;direction:ltr" />
                </v-col>

                <v-col cols="12">
                    <label>بيانات العميل </label>
                    <b-form-textarea v-model="printing.invoice_customer" class="inborder" style="height:200px;direction:ltr" />
                </v-col>
                <v-col cols="12">
                    <label>بيانات السيارة</label>
                    <b-form-textarea v-model="printing.invoice_cars" class="inborder" style="height:200px;direction:ltr" />
                </v-col>
                <v-col cols="12">
                    <label>جدول الفاتورة</label>
                    <b-form-textarea v-model="printing.invoice_table" class="inborder" style="height:200px;direction:ltr" />
                </v-col>
                <v-col cols="12">
                    <label>عناصر الفاتورة</label>
                    <b-form-textarea v-model="printing.invoice_items" class="inborder" style="height:200px;direction:ltr" />
                </v-col>
                <v-col cols="12">
                    <label>المجاميع</label>
                    <b-form-textarea v-model="printing.invoice_totals" class="inborder" style="height:200px;direction:ltr" />
                </v-col>
                <v-col cols="12">
                    <label>اسفل جدول الفاتورة</label>
                    <b-form-textarea v-model="printing.invoice_after_table" class="inborder" style="height:200px;direction:ltr" />
                </v-col>
                <v-col cols="12">
                    <label>فوتر الفاتورة</label>
                    <b-form-textarea v-model="printing.invoice_footer" class="inborder" style="height:200px;direction:ltr" />
                </v-col>
                <v-col cols="12" class="text-center">
                    <v-btn class="btn" @click="save()" style="background:darkgreen;color:#fff;width:120px;margin:5px">{{lang.save}}</v-btn>
                    <v-btn class="btn" @click="view()" style="background:red;color:#fff;width:120px;margin:5px">{{lang.view_page}}</v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default{
    name: 'printing',
    data() {
        return {
            printings: {
                invoice_header: '',
                invoice_customer: '',
                invoice_cars: '',
                invoice_table: '',
                invoice_items: '',
                invoice_totals: '',
                invoice_after_table: '',
                invoice_footer: '',
            },
            printing: {
                invoice_header: '',
                invoice_customer: '',
                invoice_cars: '',
                invoice_table: '',
                invoice_items: '',
                invoice_totals: '',
                invoice_after_table: '',
                invoice_footer: '',
            },
        }
    },
    computed: {
        
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        items: function(){
            return  {
                text: this.lang.customers,
                disabled: true,
                href: '/clientList',
            };
        },

    },
    methods: {
        view(){
            window.open("../api/print.php?test","_blank")
        },
        save(){
            const post = new FormData();
            post.append('type', "SavePrint");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth" , this.$cookies.get(this.$COOKIEPhase));
            post.append("auth" , this.$cookies.get(this.$COOKIEPhase));
            post.append('data[invoice_header]',btoa(unescape(encodeURIComponent(this.printing.invoice_header))));
            post.append('data[invoice_customer]',btoa(unescape(encodeURIComponent(this.printing.invoice_customer))));
            post.append('data[invoice_cars]',btoa(unescape(encodeURIComponent(this.printing.invoice_cars))));
            post.append('data[invoice_table]',btoa(unescape(encodeURIComponent(this.printing.invoice_table))));
            post.append('data[invoice_items]',btoa(unescape(encodeURIComponent(this.printing.invoice_items))));
            post.append('data[invoice_totals]',btoa(unescape(encodeURIComponent(this.printing.invoice_totals))));
            post.append('data[invoice_after_table]',btoa(unescape(encodeURIComponent(this.printing.invoice_after_table))));
            post.append('data[invoice_footer]',btoa(unescape(encodeURIComponent(this.printing.invoice_footer))));
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(() =>{

                this.preparedata();
            })
        },
        preparedata(){
            const post = new FormData();
            post.append('type', "PrintSet");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth" , this.$cookies.get(this.$COOKIEPhase));
            post.append('data[invoice_header]',this.printing.invoice_header);
            post.append('data[invoice_customer]',this.printing.invoice_customer);
            post.append('data[invoice_cars]',this.printing.invoice_cars);
            post.append('data[invoice_table]',this.printing.invoice_table);
            post.append('data[invoice_items]',this.printing.invoice_items);
            post.append('data[invoice_totals]',this.printing.invoice_totals);
            post.append('data[invoice_after_table]',this.printing.invoice_after_table);
            post.append('data[invoice_footer]',this.printing.invoice_footer);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) =>{
                // // console.log(response.data)
                this.printings = response.data.results.data;
                Object.keys(response.data.results.data).forEach(key => {
                    this.printing[key] = decodeURIComponent(escape(atob(response.data.results.data[key])))
                })
            })
        },
    },
    created() {
        this.preparedata();
    },
}
</script>